export default __webpack_public_path__ + "static/tiktok-3f6b6084dfb040873dea4cfca990cc03.svg";